import {
  Component,
  OnInit,
  Input
} from '@angular/core';

import { DomSanitizer } from '@angular/platform-browser';

import {
  Router
} from '@angular/router';

import { UserService } from '../../services/user.service';
import { AuthService } from '../../services/auth.service';
import { EventNotificationService } from '../../services/event_notification.service';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import * as _ from 'lodash';

@Component({
  selector: 'nestas-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.scss']
})
export class NestasToolbarComponent implements OnInit {

  @Input() steps;
  @Input() pid;
  @Input() modal;

  show = [false, false, false];
  notifications = [];
  unseen = 0;

  constructor(private _user: UserService, private _router: Router, public translate: TranslateService, private _auth: AuthService,
    private _notificationService: EventNotificationService, private _sanitizer: DomSanitizer, private cookieService: CookieService) {

  }

  ngOnInit() {

    if (this.cookieService.get('token')) { // Logged in user?
      if (!this.modal) {
        this.notificationsGetAll();
      }
    }
  }

  notificationsGetAll() {
    this._notificationService.getAll()
      .subscribe(
        (notifications: any) => {
          this.notifications = notifications;
          this.unseen = _.filter(notifications, n => { return !n['seen']; }).length;
          this.notifications.forEach(n => {
            if (n.options)
              n.options = JSON.parse(n.options);
          })
        });
  }

  me() {
    return this._user.me();
  }

  isAdmin() {
    return this._user.isAdmin();
  }

  isLoggedIn() {
    return this._user.isLoggedIn();
  }

  closeModal() {
    if (this.modal) {
      Object.keys(this.modal).forEach(k => {
        if (this.modal[k]) {
          this.modal[k] = false;
        }
      });
    }
  }

  goToStep(ref) {
    console.log("goto step", ref);
    this.closeModal();
    this._router.navigate(ref);
  }

  seenAll() {
    this._notificationService.seenAll()
      .subscribe(
        (notifications: any) => {
          this.notifications = notifications;
          this.unseen = 0;
          this.notifications.forEach(n => {
            if (n.options)
              n.options = JSON.parse(n.options);
          });
        },
        err => {
          console.log('Error seen all', err);
        }
      );
  }

  goToNotification(n) {
    this._notificationService.seen(n._id)
      .subscribe(
        (n: any) => {
          this.goToStep(n.redirect);
        },
        err => {
          this.goToStep(n.redirect);
        }
      );
  }

  logOut() {
    this._auth.logOut();
  }

  stopImpersonate() {
    this._user.stopImpersonate();
    this._router.navigate(['admin']);
  }

  showMenu(event, idx) {
    this.show.fill(false);
    var _self = this;

    function helperTouch($event) {
      function triggerClick(target) {
        var event; // The custom event that will be created

        if (document.createEvent) {
          event = document.createEvent("HTMLEvents");
          event.initEvent("click", true, true);
        } else {
          event = (<any>document).createEventObject();
          event.eventType = "click";
        }

        event.eventName = "click";

        if (document.createEvent) {
          target.dispatchEvent(event);
        } else {
          target.fireEvent("on" + event.eventType, event);
        }
      }

      triggerClick($event.target);
      _self.show[idx] = false;
      document.removeEventListener('click', helper);
      document.removeEventListener('touchend', helperTouch);
    }

    function helper() {
      _self.show[idx] = false;
      document.removeEventListener('click', helper);
      document.removeEventListener('touchend', helperTouch);
    }

    this.show[idx] = true;
    document.addEventListener('click', helper);
    document.addEventListener('touchend', helperTouch);
    event.stopPropagation();
    return false;
  }
}
